import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

export const TRAININGS_BACKEND_URLS = [
  "api.esano-trainings.de",
  "intervention.api.aas2.klips.ifp.uni-ulm.de",
] as const;

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch();
